<p>
    Η ιστοσελίδα ende.gr είναι ο επίσημος δικτυακός τόπος της ΕΝΩΣΗΣ
    ΔΙΚΑΣΤΩΝ ΚΑΙ ΕΙΣΑΓΓΕΛΕΩΝ [στο εξής η ΕΔΕ] η οποία τη λειτουργεί και τη
    διαχειρίζεται, ενώ παράλληλα ενημερώνει τα μέλη της [στο εξής
    «Χρήστες» ή «Μέλη»] ως προς το είδος και την ποσότητα πληροφοριών που
    τυχόν συλλέγει ή / και επεξεργάζεται ως Υπεύθυνος Επεξεργασίας κατά τη
    διάρκεια όλων των ψηφιακών δραστηριοτήτων της, ως αναλυτικά
    παρουσιάζονται στη συνέχεια [βλ. σκοποί επεξεργασίας] και διαβεβαιώνει
    ότι τυχόν επεξεργασία των ΔΠΧ γίνεται με μοναδικό κριτήριο το συμφέρον
    των μελών της, την πληρέστερη εξυπηρέτησή τους και ασφαλώς, την τήρηση
    της νομιμότητας, της διαφάνειας, της ακρίβειας, της διαθεσιμότητας
    καθώς και της ακεραιότητας αυτών, σε όλες τις μορφές τους.
  </p>
  <p>
    Επίσης η ΕΔΕ εναρμονιζόμενη πλήρως με τον Ευρωπαϊκό Κανονισμό
    Προστασίας Προσωπικών Δεδομένων ΕΕ 2016/679 (εφεξής «GDPR») και τον
    εφαρμοστικό Ν.4624/2019, εφαρμόζει τα κατάλληλα τεχνικά και οργανωτικά
    μέτρα για να προστατεύει τα προσωπικά δεδομένα και να διασφαλίζει την
    ιδιωτικότητα των μελών της.
  </p>
  <p>
    Τα μέλη της ΕΔΕ οφείλουν να διαβάσουν με προσοχή την Πολιτική
    Προστασίας Προσωπικών Δεδομένων, ως ισχύει για όλες τις ψηφιακές
    δραστηριότητες και υπηρεσίες της ΕΔΕ, πριν προχωρήσουν σε επίσκεψη
    ή/και στη χρήση τους και κυρίως πριν συναινέσουν στην επεξεργασία των
    προσωπικών δεδομένων τους.
  </p>
  <h4><br>Ειδικότερα:</h4>
  <p>
    Η Πολιτική Προστασίας Προσωπικών Δεδομένων ισχύει για το σύνολο των
    ψηφιακών υπηρεσιών της ΕΔΕ, ως αναλυτικά ακολουθούν στη συνέχεια.
  </p>
  <p>
    Επίσης, η ΕΔΕ, δύναται οποιαδήποτε χρονική στιγμή να τροποποιεί την
    Πολιτική Προστασίας Προσωπικών Δεδομένων, τα δε μέλη της και οι
    χρήστες των ιστοσελίδων και των υπηρεσιών της οφείλουν κάθε φορά να
    ελέγχουν για ενδεχόμενες αλλαγές και εφόσον εξακολουθούν τη χρήση,
    συμπεραίνεται ότι αποδέχονται τους τροποποιημένους όρους και
    προϋποθέσεις. Σε αντίθετη περίπτωση, οφείλουν να απέχουν από τη χρήση
    των ως άνω αναφερθέντων ιστοσελίδων και ψηφιακών υπηρεσιών της ΕΝΩΣΗΣ
    ή να επικοινωνούν με τη Γραμματεία για τη λήψη σχετικών διευκρινίσεων.
  </p>
  <p>
    Εάν κάποιος χρήστης ή μέλος δε συμφωνεί με τους όρους προστασίας των
    προσωπικών δεδομένων που προβλέπονται στο παρόν τμήμα, οφείλει να μην
    χρησιμοποιεί τις ιστοσελίδες/υπηρεσίες της ΕΔΕ.
  </p>
  <h4><br>Συλλογή Δεδομένων – Σκοποί Επεξεργασίας</h4>
  <p>
    Η ΕΔΕ διατηρεί αρχεία με τα χορηγηθέντα προσωπικά στοιχεία των μελών
    της, αποκλειστικά για λόγους λειτουργίας και παροχής των ψηφιακών
    υπηρεσιών προς τα μέλη της, ως αναλυτικά περιγράφονται στη συνέχεια.
  </p>
  <p class="font-weight-bold">[1] Ιστοσελίδα ende.gr – Επικοινωνία</p>
  <p>
    Η ΕΝΩΣH, στην ιστοσελίδα ende.gr, λαμβάνει μέσω ανηρτημένης φόρμας
    επικοινωνίας το ονομ/μο και το e-mail των ενδιαφερομένων να
    επικοινωνήσουν με τη Γραμματεία ή/και τη Διοίκηση της. Τα σχετικά
    αρχεία διατηρούνται κατά το απαραίτητο για την ικανοποίηση των
    σχετικών αιτημάτων, χρονικό διάστημα.
  </p>
  <p class="font-weight-bold">
    [2] Καταστατικές, Επιστημονικές & Πολιτιστικές Εκδηλώσεις – Live
    Streaming / Video / Φωτογραφίες
  </p>
  <p>
    Για την ολοκληρωμένη ενημέρωση όλων των μελών της η Ένωση αναμεταδίδει
    μέσω διαδικτύου [live streaming] τις εργασίες των τακτικών και
    έκτακτων Γενικών Συνελεύσεων, των επιστημονικών ημερίδων και των
    πολιτιστικών εκδηλώσεων τις οποίες η ίδια διοργανώνει, είτε για την
    επίτευξη των καταστατικών σκοπών της είτε για την ανάπτυξη των
    επιστημονικών και πολιτιστικών δράσεών της. Η λήψη και η μετάδοση
    εικόνων, video και η ανάρτηση φωτογραφιών των παρισταμένων μελών, των
    ομιλητών και των προσκεκλημένων στις ως άνω εκδηλώσεις
    πραγματοποιείται αποκλειστικά για το συγκεκριμένο σκοπό και μόνο. Τα
    σχετικά στα οποία απεικονίζονται ανήλικοι, αποκλείονται προληπτικώς
    και στο σύνολό τους. Τα σχετικά αρχεία παραμένουν στην ιστοσελίδα της
    ΕΔΕ και στο κεντρικό αρχείο της ένωσης, πάντοτε στη διάθεση των μελών
    της και στα πλαίσια τήρησης των προβλέψεων του ΓΚΠΔ.
  </p>
  <p class="font-weight-bold">[3] Ηλεκτρονικά Δελτία [Newsletter]</p>
  <p>
    Για την πληρέστερη ενημέρωση των μελών της η Ένωση διανέμει όλες τις
    αναρτήσεις της στην ιστοσελίδα ende.gr καθώς και τυχόν επείγουσες
    ανακοινώσεις μέσω ηλ. δελτίου [Newsletter]. Τα μέλη της Ένωσης,
    προκειμένου να εγγραφούν στη λίστα παραληπτών των ηλεκτρονικών
    ενημερωτικών δελτίων, χορηγούν την διεύθυνση της ηλ. θυρίδας [e-mail]
    η οποία διατηρείται στη σχετική λίστα καθ’ όλη τη διάρκεια συμμετοχής
    των μελών στη συγκεκριμένη ενημερωτική δράση.
  </p>
  <p>
    Η ΕΔΕ και ειδικότερα το Διοικητικό Συμβούλιο είναι δυνατόν να
    επεξεργάζεται τμήμα ή το σύνολο των στοιχείων των μελών της, για
    λόγους στατιστικούς.
  </p>
  <p class="font-weight-bold">[4] Ψηφιακή Κάλπη ΖΕΥΣ</p>
  <p>
    Για την ενίσχυση των συμμετοχικών διαδικασιών και την ανάδειξη των θέσεων των μελών της, η ΕΔΕ έχει συνάψει σύμβαση συνεργασίας με το <a href="https://grnet.gr/company/" target="_blank">Εθνικό Δίκτυο Υποδομών Τεχνολογίας και Έρευνας (ΕΔΥΤΕ Α.Ε. – GRNET), φορέα του Υπουργείου Ψηφιακής Διακυβέρνησης</a>, ώστε να κάνει χρήση της ψηφιακής κάλπης ΖΕΥΣ. Η επεξεργασία των προσωπικών δεδομένων των μελών της ΕΔΕ αφορά κατά περίπτωση: [α] Ονοματεπώνυμο [β] διεύθυνση ηλ. ταχυδρομείου [γ] αριθμό κινητού τηλεφώνου.
  </p>
  <p>Η Ένωση Δικαστών και Εισαγγελέων παραμένει ο υπεύθυνος επεξεργασίας των σχετικών στοιχείων, η δε ΕΔΥΤΕ ΑΕ, εκτελεί τη σχετική επεξεργασία, ως εκτελών την επεξεργασία στα πλαίσια της ισχύουσας συμβατικής σχέσεως των δύο μερών και αποκλειστικώς για την λειτουργία της ψηφιακής κάλπης και τη συμμετοχή των μελών μας σε αυτή. Τα σχετικά ως άνω στοιχεία χορηγούνται από τα μέλη της ΕΔΕ κατόπιν συμπλήρωσης της σχετικής φόρμας συγκατάθεσης στη διεύθυνση: <a href="http://gdpr.ende.gr/">gdpr.ende.gr</a></p>
  <h4><br>Κοινωνικά δίκτυα</h4>
  <p>
    Για την παροχή των ψηφιακών υπηρεσιών της η ΕΔΕ διατηρεί σελίδα στα
    κοινωνικά δίκτυα. Οι δημοσιεύσεις, αναρτήσεις και μεταδόσεις μέσω
    αυτών, πραγματοποιούνται για τους ίδιους, ως άνω σκοπούς επεξεργασίας,
    λαμβάνοντας υπόψη και τους δημοσιευθέντες όρους χρήσης και προστασίας
    δεδομένων των εν λόγω μέσων.
  </p>
  <h4><br>Cookies</h4>
  <p>
    Η ΕΝΩΣΗ χρησιμοποιεί cookies για την αρμονική λειτουργία της
    ιστοσελίδας της, για την βελτιωμένη λειτουργία των ψηφιακών υπηρεσιών
    της καθώς και σε όσες περιπτώσεις αξιοποιούνται εκ των ψηφιακών μέσων
    και εφαρμογών λογισμικού των οποίων κάνει χρήση.
  </p>
  <h4><br>Σχετικά με τα cookies</h4>
  <p>
    Τα cookies είναι μικρά αρχεία κειμένου που περιέχουν πληροφορίες οι
    οποίες αποθηκεύονται στο web browser του υπολογιστή κατά την περιήγηση
    σε ιστοσελίδες και εφαρμογές και μπορούν να αφαιρεθούν ανά πάσα
    στιγμή. Χρησιμοποιούνται cookies για την καλύτερη δυνατή λειτουργία
    της ιστοσελίδας ende.gr, τη σωστή περιήγηση, τη σύνδεση και τη
    μετακίνηση επίσης σελίδες παροχής υπηρεσιών, τις εφαρμογές και τις
    ψηφιακές πλατφόρμες οι οποίες έχουν επιλεγεί από την ΕΔΕ για τη
    λειτουργία και την παροχή των ψηφιακών υπηρεσιών προς τα μέλη της.
    Επίσης, χρησιμοποιούνται τα cookies για να λάβουμε τις απαραίτητες
    πληροφορίες για την βελτίωση των υπηρεσιών, της δομής και του
    περιεχομένου του ιστοτόπου ende.gr και των λοιπών σελίδων και ψηφιακών
    εφαρμογών.
  </p>
  <h4><br>Τι πληροφορίες συλλέγουμε;</h4>
  <p>
    Τα cookies και οι πληροφορίες που συλλέγονται διακρίνονται στις
    ακόλουθες κατηγορίες:
  </p>
  <p>
    Τα απολύτως απαραίτητα cookies είναι ουσιαστικής σημασίας για την ορθή
    λειτουργία των ιστοτόπων και των ψηφιακών εφαρμογών της ΕΔΕ.
    Επιτρέπουν δε την περιήγηση και την ορθή χρήση των λειτουργιών των
    παρεχομένων υπηρεσιών. Αποκλειομένης της χρήσης τους, δεν θα είναι
    αποτελεσματική η λειτουργία των ανωτέρω.
  </p>
  <p>
    Τα cookies επιδόσεων συλλέγουν πληροφορίες σχετικά με τον τρόπο που οι
    επισκέπτες και τα μέλη των ιστοσελίδων της ΕΔΕ χρησιμοποιούν τους ως
    άνω ιστοτόπους και τις ψηφιακές εφαρμογές ήτοι, ποιές σελίδες
    επισκέπτονται συχνότερα και αν προκύπτουν τυχόν μηνύματα σφαλμάτων.
    Χρησιμοποιούνται δε αποκλειστικά για τη βελτίωση των επιδόσεων των
    ανωτέρω ιστοσελίδων και εφαρμογών.
  </p>
  <p>
    Τα μέλη της ΕΔΕ καθώς και οι επισκέπτες / χρήστες των ιστοσελίδων και
    των ψηφιακών εφαρμογών της μπορούν να αρνηθούν την παροχή της σχετικής
    συναίνεσης στο εμφανιζόμενο μήνυμα κατά την είσοδό τους σε αυτές, ώστε
    να μην είναι δυνατή η χρήση των cookies.
  </p>
  <p>
    H μη αποδοχή αυτών των cookies, είναι δυνατόν να επηρεάσει την απόδοση
    και τη λειτουργικότητα των ιστοτόπων και των ψηφιακών εφαρμογών.
  </p>
  <h4><br>Περίοδος αποθήκευσης Δεδομένων Προσωπικού Χαρακτήρα [ΔΠΧ]</h4>
  <p>
    Τα προσωπικά δεδομένα των μελών της ΕΔΕ αποθηκεύονται καθ’ όλη τη
    διάρκεια ισχύος της εγγραφής τους σε αυτή, εφόσον έχει χορηγηθεί η
    συγκατάθεσή τους για το συγκεκριμένο κάθε φορά σκοπό επεξεργασίας. Η
    ΕΔΕ δύναται να διατηρεί αρχεία επικοινωνίας, αλληλογραφίας και
    παραστατικών ακόμη και μετά τη διαγραφή των μελών της, προκειμένου να
    ανταποκριθεί στις εκ του νόμου υποχρεώσεις της. Το ονομ/μο, το e-mail
    και το κινητό τηλ. των μελών διατηρούνται, περιοριστικά για όσο
    χρονικό διάστημα διαρκεί ο νόμιμος σκοπός της επεξεργασίας, για την
    εξυπηρέτηση του οποίου είχαν συλλεγεί αρχικά, κατόπιν της ελεύθερης
    και ρητής συγκατάθεσής των χρηστών/μελών της.
  </p>
  <h4><br>Δικαίωμα πρόσβασης & ενημέρωσης των μελών</h4>
  <p>
    Τα μέλη της ΕΔΕ, έχουν τη δυνατότητα να επικοινωνήσουν με τη
    Γραμματεία προκειμένου να διασταυρώσουν την ύπαρξη προσωπικού αρχείου,
    την διόρθωση αυτού, την αλλαγή του ή/και την διαγραφή του. Ρητώς
    εξαιρούνται, τα αρχεία τα οποία η ΕΔΕ υποχρεούται εκ του νόμου να
    διατηρήσει στο αρχείο της.
  </p>
  <p class="font-weight-bold">Επίσης έχουν τη δυνατότητα:</p>
  <ul>
    <li>
      Να ασκήσουν τα δικαιώματα πρόσβασης και αντίρρησης σύμφωνα με τα
      άρθρα 13 επόμενα του Ευρωπαϊκού Κανονισμού Προστασίας Προσωπικών
      Δεδομένων 2016/ 679, επικοινωνώντας με την κ. Κατερίνα Τρακανιάρη,
      αποστέλλοντας γραπτή αίτηση, η οποία θα αφορά σε συγκεκριμένο αίτημα
      ή/ και ενέργεια, στην εξής ηλεκτρονική διεύθυνση endikeis@otenet.gr.
    </li>
    <li>
      Να ζητήσουν την διαγραφή των δεδομένων τους, ανακαλώντας την
      συγκατάθεση που έχουν προηγουμένως δώσει.
    </li>
    <li>
      Να απευθυνθούν στην αρμόδια Αρχή Προστασίας Δεδομένων Προσωπικού
      Χαρακτήρα (Κηφισίας 1-3, Τ.Κ. 115 23, Αθήνα, Τηλ: +30 210 6475600,
      email: <a href="mailto:info@dpa.gr">info@dpa.gr</a>
    </li>
  </ul>
